import React from 'react'
import NewCompactProgressBar from './NewCompactProgressBar'
import { CompressedMSRLoader } from '../PDRCredits'

export const CompactPDRWrapper = ({ currentPerson }) => <NewCompactProgressBar currentPerson={currentPerson} />

export default ({ loading, data }) =>
  loading ? <CompressedMSRLoader /> : <CompactPDRWrapper currentPerson={data.currentPerson} />
